import { render } from "./ProjectTemplate1.vue?vue&type=template&id=575060c3"
import script from "./ProjectTemplate1.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__